module.exports = __webpack_public_path__ + "static/media/0.6ed9e07e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/0.jpg
// module id = 533
// module chunks = 0